import { render, staticRenderFns } from "./SubCommunityNFTStaking.vue?vue&type=template&id=70701657&scoped=true&"
import script from "./SubCommunityNFTStaking.vue?vue&type=script&lang=js&"
export * from "./SubCommunityNFTStaking.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityNFTStaking.vue?vue&type=style&index=0&id=70701657&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70701657",
  null
  
)

export default component.exports